// extracted by mini-css-extract-plugin
export default {"title":"NoProductsFound_title__KgjLX","text":"NoProductsFound_text__20meu"};